import { sizes } from '../../../../lib/viewport';
import { ScreenSize } from './types';
function between(from: ScreenSize, to: ScreenSize): string {
    const [minWidth] = sizes[from];

    // `large` does not have the second value. In that case, use the first value
    const maxWidth = sizes[to][1] ? sizes[to][1] : sizes[to][0];

    const queryString = `(min-width: ${minWidth}px) and (max-width: ${maxWidth}px)`;

    return `@media ${queryString}`;
}

export default between;
